export { default } from './Maximize';